import { Stack, Typography } from '@mui/material'
import React, { useCallback, useState } from 'react'
import RainbowTextField from '@components/RainbowTextField/RainbowTextField'
import { WALLET_SETUP_ROUTES } from '@utils/walletSetupRoutes'
import plug from '@assets/icons/plug-logo.png'
import { importWallet } from '@plug-core/handlers/walletActions/wallet'
import { useCurrentWallet } from '@plug-core/state'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import ErrorPopup from '@components/ErrorPopup'
import Button from '@components/Button'
import useFindTokens from '@plug-core/hooks/useFindTokens'

export const WalletSetupImportSeed = () => {
  const navigate = useNavigate()
  const [phrase, setPhrase] = useState('')
  const [importError, setImportError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const { t } = useTranslation()
  const { findTokens } = useFindTokens()
  const { setCurrentWallet } = useCurrentWallet()

  const onImportWallet = useCallback(() => {
    setIsLoading(true)

    importWallet(phrase.trim())
      .then(async (response) => {
        setCurrentWallet(response.principal)
        await findTokens(response.principal)
        navigate(WALLET_SETUP_ROUTES.PASSWORD)
      })
      .catch((e) => {
        setImportError(true)
      })
  }, [phrase])

  return (
    <>
      <ErrorPopup
        visible={!!importError}
        title={t('importWallet.error')}
        description={t('importWallet.invalidSeed')}
        onDismiss={() => setImportError(false)}
      />
      <Stack height="100%" justifyContent="center" spacing={4} px={4}>
        <Stack spacing={0.5}>
          <img src={plug} width="120px" style={{ alignSelf: 'center' }} />
          <Typography fontWeight="bold" textAlign="center" variant="h5">
            {t('importWallet.title')}
          </Typography>
          <Typography textAlign="center" variant="body2" color="text.secondary">
            {t('importWallet.description')}
          </Typography>
        </Stack>
        <Stack spacing={2}>
          <RainbowTextField
            placeholder={t('importWallet.placeholder')}
            multiline
            rows={4}
            fullWidth
            value={phrase}
            onChange={(e) => setPhrase(e.target.value)}
          />
          <Button
            variant="rainbow"
            fullWidth
            disabled={phrase.length === 0 || isLoading}
            onClick={onImportWallet}
            loading={isLoading}
          >
            continue
          </Button>
        </Stack>
      </Stack>
    </>
  )
}
